import React from 'react';

import { useIntl } from 'react-intl';
import { WidgetArticleImageContent, jFileLittle } from 'jamespot-user-api';

import {
    CSSEditor,
    CSSEditorComponentWrapper,
    CSSEditorWidgetProperties,
} from 'components/Editors/components/Editor.style';
import { EditorUploader } from 'components/Editors/components/EditorUploader';

import { WidgetStateProps } from 'jamespot-user-api';

import { JRCButton } from 'components/JRCButton/JRCButton';
import { EditorImageUpload } from 'components/Editors/components/EditorImageUpload';

import { WidgetMissingToken } from '../components/WidgetMissingToken';

/**
 * Custom widget image editor for article widget image
 */
export const JRCWidgetArticleImageEditor = ({
    token,
    content,
    onSave,
    onStateChange,
}: {
    token: string | undefined;
    content: WidgetArticleImageContent;
    onChange: (content: Partial<WidgetArticleImageContent>, override?: boolean) => void;
    onSave: (content: Partial<WidgetArticleImageContent>) => void;
    onStateChange: (state: WidgetStateProps) => void;
}) => {
    const intl = useIntl();

    const onUploadSuccess = (fileResponse: jFileLittle) => {
        onSave({ file: fileResponse });
        onStateChange({ busy: false, loading: false, initialized: true });
    };

    return (
        <CSSEditor>
            <CSSEditorWidgetProperties>
                {!token && <WidgetMissingToken />}
                {!content.file && token && (
                    <CSSEditorComponentWrapper>
                        <EditorUploader
                            token={token}
                            uniqid={'name'}
                            accept={'image/png, image/jpeg, image/jpg'}
                            label={intl.formatMessage({ id: 'WIDGET_Article_Image_Empty_Label' })}
                            multiple={false}
                            onUploadStart={() => onStateChange({ loading: true })}
                            onUploadSuccess={onUploadSuccess}
                        />
                    </CSSEditorComponentWrapper>
                )}
                {content.file && token && (
                    <EditorImageUpload token={token} initialFile={content.file} onUploadSuccess={onUploadSuccess}>
                        {(_, openCrop) => {
                            return (
                                <>
                                    <JRCButton
                                        onClick={openCrop}
                                        label={intl.formatMessage({ id: 'PANEL_Crop_Image' })}
                                        minWidth="100%"
                                        icon="icon-crop"
                                    />
                                </>
                            );
                        }}
                    </EditorImageUpload>
                )}
            </CSSEditorWidgetProperties>
            <JRCButton onClick={() => onSave(content)} variant={'outlined'} minWidth={'100%'}>
                {intl.formatMessage({ id: 'PANEL_Save_And_Close' })}
            </JRCButton>
        </CSSEditor>
    );
};
